<template>
    <div>

        <v-dialog v-model="shownRelay" width="700">

            <v-card>
                <div class="primary white--text d-flex align-center">
                    <v-card-title class="py-1 my-1 flex-grow-1">
                            Excluded Words
                    </v-card-title>

                    <div :class="!searchStr ? 'search-title' : 'search-title-words'">
                        <v-text-field
                                prepend-inner-icon="mdi-magnify"
                                placeholder="Search"
                                persistent-placeholder
                                hide-details
                                dense
                                v-model="searchStr"
                                color="white"
                                dark
                                outlined

                        ></v-text-field>
                    </div>
                    <v-btn
                            class="mx-2"
                            icon
                            color="white"
                            @click="shownRelay = false"
                            dark
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <div v-if="loading" style="height: 200px" class="d-flex align-center justify-center">
                    <loader :size="52"></loader>
                </div>

                <div v-else style="height: 400px">
                    <v-data-table
                            :search="searchStr"
                            dense
                            fixed-header
                            height="100%"
                            class="fill-height of-y"
                            hide-default-footer
                            :headers="wordHeaders"
                            :items="excludedWordsView"
                            :options="{itemsPerPage: excludedWordsView.length}"
                            ref="wordsTable"
                    >
                        <template v-slot:item.action="{item}">
                            <v-tooltip left>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            icon
                                            small
                                            @click="restoreWord(item)"
                                            color="secondary"
                                            v-on="on"
                                            :loading="loadingWords.includes(item.documentType + item.string)"
                                    >
                                        <v-icon>mdi-restore</v-icon>
                                    </v-btn>
                                </template>
                                Restore
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </div>
            </v-card>

        </v-dialog>


    </div>
</template>

<script>
import Loader from "@/components/General/Loader/Loader";
import {arrSplice} from "@/core/codeFunctions";
export default {
    components: {Loader},
    props: {
        shown: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            excludedWords: [],
            loadingWords: [],
            searchStr: "",
            wordHeaders: [
                {value: 'documentTypeDisplay', text: 'DocumentType', sortable: true},
                {value: 'string', text: 'Excluded Word', sortable: true},
                {value: 'action', text: '', sortable: false, width: 50},
            ],
        }
    },
    watch: {
        shown: {
            immediate: true,
            handler(val) {
                if (val)
                    this.init();
            }
        }
    },
    methods: {
        async init() {
            try {
                this.loading = true
                this.excludedWords = await this.$newReq("GET", `recruitment/excludedWords`);
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.loading = false
            }
        },
        async restoreWord(item) {
            const key = item.documentType + item.string
            try {
                this.loadingWords.push(key)
                await this.$newReq("DELETE", `recruitment/excludedWord`, {
                    documentType: item.documentType,
                    string: item.string
                });
                this.$emit('restore', item)
                arrSplice(this.excludedWords, (item) => item.documentType + item.string === key)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                arrSplice(this.loadingWords, wordKey => wordKey === key)
            }
        }
    },
    computed: {
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit("update:shown", val)
            }
        },
        excludedWordsView() {
            return this.excludedWords.map(obj => {
                return {
                    ...obj,
                    documentTypeDisplay: obj.documentType.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toUpperCase()
                }
            }).sort((a,b) => {
                if (a.documentTypeDisplay === b.documentTypeDisplay)
                    return a.string > b.string ? 1 : -1
                return a.documentTypeDisplay > b.documentTypeDisplay ? 1 : -1
            })
        }
    },
}
</script>

<style scoped>
    .search-title {
        width: 105px;
        transition: width 300ms ease-in-out;
    }
    .search-title:focus-within {
        width: 250px;
    }
    .search-title-words {
        width: 250px;
    }
</style>